<template>
  <section>
    <div class="info bg-secondary-13 p-3 rounded mt-2">
      <div class="d-flex justify-content-center">
        <span
          class="fa-stack fa-1x color-green font-14 align-self-md-center mt-3 mb-md-3 mt-md-0"
        >
          <em class="fas fa-circle fa-stack-2x" />
          <em class="fas fa-usd-square fa-stack-1x fa-inverse" />
        </span>
        <div class="row mx-0 flex-fill">
          <div class="col-12 col-md-3 mb-3">
            <span class="data-label">
              Tipo de Requesición:
            </span>
            {{ info.requisitionType.name }}
          </div>
          <template v-if="isAuction">
            <div class="col-12 col-md-3 mb-3">
              <span class="data-label">
                Nombre de Suplidor:
              </span>
              {{ info.supplierName }}
            </div>
            <div class="col-12 col-md-3 mb-3">
              <span class="data-label">
                Número de Contrato:
              </span>
              {{ info.contractNumber }}
            </div>
          </template>
          <div class="col-12 col-md-3 mb-3">
            <span class="data-label">
              Artículos:
            </span>
            {{ info.articlesCount }}
          </div>
        </div>
      </div>
      <div class="row mx-0 justify-content-between bg-gray-9 rounded px-4 py-3">
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <span class="data-label">
            Número de Requisición:
          </span>
          {{ info.requisitionNumber | empty }}
        </div>
        <div class="col-12 col-md-3 mb-3 mb-md-0">
          <span class="data-label">
            Fecha de Requisición:
          </span>
          {{ info.requisitionDate | date | empty }}
        </div>
        <div class="col-12 col-md-3">
          <span class="data-label">
            Estatus:
          </span>
          {{ info.requisitionStatus.name | empty }}
        </div>
        <template v-if="isSubmitted">
          <div class="w-100 mt-3" />
          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <span class="data-label">
              Request Status:
            </span>
            {{ info.requestStatus | empty }}
          </div>
          <div class="col-12 col-md-3 mb-3 mb-md-0">
            <span class="data-label">
              Budget Check:
            </span>
            {{ info.budgetCheck | date | empty }}
          </div>
          <div class="col-12 col-md-3">
            <span class="data-label">
              Hold Status:
            </span>
            {{ info.holdStatus | empty }}
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import requisitionTypes from '@/utils/constants/pei/materials-equipment-requisition/requisitionType.js';

export default {
  name: 'RequisitionInfo',
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isSubmitted: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    isAuction() {
      return this.info.requisitionType?.id == requisitionTypes.Auction;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info {
  .data-label {
    display: block;
    font-size: 0.875rem !important;
  }
}
</style>
